import { useQuery } from '@tanstack/react-query';
import { activityService } from '@/services';
import { queryKeys } from '@/services/query-keys';

export const useTradeActivity = (id: number, enabled: boolean = true) => {
  return useQuery({
    queryKey: queryKeys.trades.activity(id),
    queryFn: () => activityService.getActivity(id),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: enabled && id > 0,
  });
};
